import type { ReactNode } from 'react'
import { cx } from '../cx'
import s from './Chip.module.css'

/**
 * A small label: a status, a tag, a count. Healthy stays quiet (neutral); only problems get colour, so the eye lands
 * on them first. `warn` means "look at this", `bad` means "act".
 */
export function Chip(props: { children: ReactNode; tone?: 'neutral' | 'accent' | 'warn' | 'bad' | 'outline'; title?: string }) {
  return (
    <span className={cx(s.chip, s[props.tone ?? 'neutral'])} title={props.title}>
      {props.children}
    </span>
  )
}
